<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() | translate }}</h3>
    </div>
  </div>
  <div class="card-body scroll" [perfectScrollbar]="{ wheelPropagation: false }">
    <form [formGroup]="form" class="form form-group mb-0">
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'DOCS_MODULE.CATEGORY.NAME' | translate }}</mat-label>
        <input matInput type="text" formControlName="name" required />
        <mat-error *ngIf="isInvalid('name')">{{
          getErrorMessage('DOCS_MODULE.CATEGORY.NAME' | translate)
        }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'DOCS_MODULE.CATEGORY.ENTITY_TYPES' | translate }}</mat-label>
        <mat-select
          multiple
          formControlName="entityTypes"
          [compareWith]="compareEntityTypes"
          required
        >
          <mat-option
            *ngFor="let type of entityTypes"
            [value]="type"
            [matTooltip]="isSavedEntityType(type.id) ? 'Can\'t unselect a saved type' : null"
            [disabled]="isSavedEntityType(type.id)"
            >{{ stringUtils.formatEnumString(type.entity_type) }}</mat-option
          >
        </mat-select>
        <mat-error *ngIf="isInvalid('entityTypes')">{{
          getErrorMessage('DOCS_MODULE.CATEGORY.ENTITY_TYPES' | translate)
        }}</mat-error>
      </mat-form-field>
      <div *ngIf="!data.viewMode && !isSuperAdmin" class="w-100 mb-4">
        <kt-general-autocomplete
          [label]="'Program'"
          [dataPath]="'data'"
          [hint]="'Compliance Program'"
          [control]="form.get('program')"
          [change]="handleProgramChange.bind(this)"
          [loadItemsFunction]="getProgramAutocomplete"
          [optionFormatter]="formatProgramOption"
          [valueFormatter]="formatProgramOption"
        ></kt-general-autocomplete>
      </div>
      <div class="w-100 mb-4" *ngIf="!isSuperAdmin">
        <kt-general-autocomplete
          [label]="'Standards'"
          [chipList]="true"
          [dataPath]="'data'"
          [hint]="'Compliance Standards'"
          [control]="form.get('standards')"
          [objects]="form.get('standards').value"
          [change]="handleStandardChange.bind(this)"
          [loadItemsFunction]="getStandardAutocomplete"
          [optionFormatter]="formatStandardOption"
          [valueFormatter]="formatStandardOption"
          [formatNewObjectFn]="formatNewStandard"
          [readOnly]="data.viewMode || !form.get('program').value"
        ></kt-general-autocomplete>
      </div>
      <div class="w-100 mb-4" *ngIf="!isSuperAdmin">
        <kt-general-autocomplete
          #formAutocomplete
          [label]="'Form'"
          [dataPath]="'data'"
          [control]="formAutocomplete"
          [loadItemsFunction]="getFormAutocomplete"
          [optionFormatter]="formatFormOption"
          [valueFormatter]="formatFormOption"
          [readOnly]="data.viewMode"
        ></kt-general-autocomplete>
      </div>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'DOCS_MODULE.CATEGORY.NOTIFICATION_LEVEL' | translate }}</mat-label>
        <mat-select formControlName="notificationLevel" required>
          <mat-option *ngFor="let level of NotificationLevels" [value]="level">{{
            stringUtils.formatEnumString(level)
          }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('notificationLevel')">{{
          getErrorMessage('DOCS_MODULE.CATEGORY.NOTIFICATION_LEVEL' | translate)
        }}</mat-error>
      </mat-form-field>
      <fieldset class="border border-secondary rounded mb-2">
        <legend
          style="
            font-size: inherit !important;
            width: fit-content !important;
            padding-left: 0.75em !important;
          "
          class="font-weight-bold pr-2 mb-0"
        >
          {{ 'DOCS_MODULE.CATEGORY.PHI' | translate }}
        </legend>
        <div class="d-flex align-items-center justify-content-between px-5 pb-2">
          <div class="d-flex align-items-center">
            <mat-label style="width: 150px !important" class="d-inline-block">
              {{ (form.get('phi').value ? 'GLOBAL.ACTIVE' : 'GLOBAL.INACTIVE') | translate }}
            </mat-label>
            <mat-slide-toggle formControlName="phi"></mat-slide-toggle>
          </div>
          <div class="d-flex align-items-center">
            <mat-label style="width: 70px !important" class="d-inline-block">
              {{ 'GLOBAL.OVERRIDE' | translate }}
            </mat-label>
            <mat-checkbox formControlName="overridePHI"></mat-checkbox>
          </div>
        </div>
      </fieldset>
      <fieldset class="border border-secondary rounded mb-2">
        <legend
          style="
            font-size: inherit !important;
            width: fit-content !important;
            padding-left: 0.75em !important;
          "
          class="font-weight-bold pr-2 mb-0"
        >
          {{ 'DOCS_MODULE.CATEGORY.PATIENT_ONLY' | translate }}
        </legend>
        <div class="d-flex align-items-center justify-content-between px-5 pb-2">
          <div class="d-flex align-items-center">
            <mat-label style="width: 150px !important" class="d-inline-block">
              {{
                (form.get('patientOnly').value ? 'GLOBAL.ACTIVE' : 'GLOBAL.INACTIVE') | translate
              }}
            </mat-label>
            <mat-slide-toggle formControlName="patientOnly"></mat-slide-toggle>
          </div>
          <div class="d-flex align-items-center">
            <mat-label style="width: 70px !important" class="d-inline-block">
              {{ 'GLOBAL.OVERRIDE' | translate }}
            </mat-label>
            <mat-checkbox formControlName="overridePatientOnly"></mat-checkbox>
          </div>
        </div>
      </fieldset>
      <fieldset class="border border-secondary rounded">
        <legend
          style="
            font-size: inherit !important;
            width: fit-content !important;
            padding-left: 0.75em !important;
          "
          class="font-weight-bold pr-2 mb-0"
        >
          {{ 'DOCS_MODULE.CATEGORY.MOBILE_VISIBLE' | translate }}
        </legend>
        <div class="d-flex align-items-center justify-content-between px-5 pb-2">
          <div class="d-flex align-items-center">
            <mat-label style="width: 150px !important" class="d-inline-block">
              {{
                (form.get('mobileVisible').value ? 'GLOBAL.ACTIVE' : 'GLOBAL.INACTIVE') | translate
              }}
            </mat-label>
            <mat-slide-toggle formControlName="mobileVisible"></mat-slide-toggle>
          </div>
          <div class="d-flex align-items-center">
            <mat-label style="width: 70px !important" class="d-inline-block">
              {{ 'GLOBAL.OVERRIDE' | translate }}
            </mat-label>
            <mat-checkbox formControlName="overrideMobileVisible"></mat-checkbox>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      *ngIf="!data.viewMode"
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
